import { uuid } from '../uuid'

const WINDOW_ID = uuid()

export function windowIdGet(): string {
  return WINDOW_ID
}
